import moment from 'moment';
import {i18n} from "./i18n";
import {unfold} from "./objects";
import {DATETIME_DISPLAY_FORMAT, ISO_8601_DATE_TIME_FORMAT} from "./dateTime";
import {FilterValidator} from "./validation";

/**
 * Returns human-readable filter component
 * @param langPath {string}
 * @param filterObject {Object}
 * @param renderValues {Object}
 * @param filters {Object}
 * @returns {string}
 * @recursive
 */
const makeHumanReadableComponent = (langPath, filterObject, renderValues, filters) => {
    const key = Object.keys(filterObject)[0];
    const type = filters.getType(key);
    FilterValidator.validate(filterObject[key], type.validation);
    return type.render(langPath, key, filterObject[key], renderValues, filters);
};

/**
 * Returns translated filter
 * @param filterName {string}
 * @param params {Array}
 * @returns {string}
 */
const trFilter = (filterName, params = undefined) => i18n.t('base.filter.' + filterName, params);

/**
 * Returns array of translated parameters
 * @param langPath {string}
 * @param params {Array}
 * @param values {Object}
 * @returns {string[]}
 */
const trParams = (langPath, params, values) => params.map(param => {
    const fullParam = langPath + '.' + param;
    if (unfold(values, fullParam) !== undefined) {
        return unfold(values, fullParam);
    } else {
        if (i18n.te(fullParam)) {
            return i18n.t(fullParam);
        } else if (moment(param, ISO_8601_DATE_TIME_FORMAT, true).isValid()) {
            return moment(param).format(DATETIME_DISPLAY_FORMAT);
        } else {
            return param;
        }
    }
});

export {makeHumanReadableComponent, trFilter, trParams};